window.cartdata = null;
if (!window.location.href.includes('?checkout')) {
    document.querySelectorAll(".checkout_block").forEach(function (checkout) {
        checkout.style.display = 'none';
    })
} else {
    $("#customer_login").prepend('<input type="hidden" name="return_to" value="/checkout" />');
    $("#create_customer").prepend('<input type="hidden" name="return_to" value="/checkout" />');
    var url = $(".register_btn").attr("href") + '?checkout';
    $(".register_btn").attr("href", url);
}

function openloader() {
    document.querySelector(".loading-spinner").style.display = "block";
}

function updatecart(url, btn) {
    var id = btn ? btn.getAttribute("data-id") : 0;
    openloader();

    if (url.includes('/cart/change')) {
        document.querySelectorAll(".custom-control-input.bonus-product-checkbox").forEach(function (input) {
            if (input.value == id) {
                input.click();
                return;
            }
        })
    }
    fetch(url).then(function (response) {
        return response.text();
    })
}
function handleize(str) {
    return str
      .toLowerCase() // make it lowercase
      .trim() // remove leading/trailing spaces
      .replace(/[^a-z0-9\s-]/g, '') // remove special characters
      .replace(/\s+/g, '-') // replace spaces with hyphens
      .replace(/-+/g, '-'); // avoid multiple hyphens
  }
function updateCartUI(data, isProduct) {

    document.querySelectorAll(".js-tab-link-cart span").forEach(function (qty) {
        qty.textContent = data.item_count;
    });

    document.querySelectorAll(".cart_icon .value").forEach(function (qtyq) {
        qtyq.textContent = data.item_count;

    });
    if (isProduct) {
        r$1("cart:updated");
    }


    document.querySelector(".loading-spinner").style.display = "none";

    if (data.item_count == 0) {
        document.querySelector(".mfk-minicart-body-wrapper") ? document.querySelector(".mfk-minicart-body-wrapper").style.display = 'none' : "";
        document.querySelector(".mfk-minicart-body-gradient") ? document.querySelector(".mfk-minicart-body-gradient").style.display = 'none' : "";
        document.querySelector(".mfk-minicart-empty-msg") ? document.querySelector(".mfk-minicart-empty-msg").style.display = 'none' : "";
        document.querySelector(".Continue-btnun.empty_cart a") ? document.querySelector(".Continue-btnun.empty_cart a").style.display = 'flex' : "";
        document.querySelector(".mfk-minicart-empty-msg.mfk-show-on-empty") ? document.querySelector(".mfk-minicart-empty-msg.mfk-show-on-empty").style.display = 'flex' : "";
        document.querySelector(".quick-cart__footer") ? document.querySelector(".quick-cart__footer").classList.remove('active') : "";
        document.querySelector(".bonus-discount-line-items-container") ? document.querySelector(".bonus-discount-line-items-container").style.display = 'none' : "";
    } else {
        // document.querySelector(".mfk-minicart-body-wrapper") ? document.querySelector(".mfk-minicart-body-wrapper").style.display = 'block' : "";
        document.querySelector(".mfk-minicart-body-gradient") ? document.querySelector(".mfk-minicart-body-gradient").style.display = 'block' : "";
        document.querySelector(".mfk-minicart-empty-msg") ? document.querySelector(".mfk-minicart-empty-msg").style.display = 'none' : "";
        document.querySelector(".Continue-btnun.empty_cart a") ? document.querySelector(".Continue-btnun.empty_cart a").style.display = 'none' : "";
        document.querySelector(".mfk-minicart-empty-msg.mfk-show-on-empty") ? document.querySelector(".mfk-minicart-empty-msg.mfk-show-on-empty").style.display = 'none' : "";
        document.querySelector(".quick-cart__footer") ? document.querySelector(".quick-cart__footer").classList.add('active') : "";
        // document.querySelector(".bonus-discount-line-items-container") ? document.querySelector(".bonus-discount-line-items-container").style.display = 'block' : "";

    }

    var cartItem = "";
var hasFreeSample = false; // Track if any item has 50ml or 100ml

data.items.forEach(function (item, index) {
    var option = "";
    item.options_with_values.forEach(function (option_value) {
        option += `<div>${option_value.name}: ${option_value.value}</div>`;
    });

    var price = formatMoney(item.price);

    // Check for 50ml or 100ml in the option string
    var freeSampleClass = "";
    if (/50ml|100ml/i.test(option)) {
        freeSampleClass = "pi-free-sample-enabled";
        hasFreeSample = true;
    }

    cartItem += `
    <div class="cart__item showdata" 
         data-component="quickCartItem" 
         data-id="47866108510541" 
         style="--delay-offset-multiplier: ${index + 1}; ${item.price == 0 ? '' : 'margin-bottom: 20px;'}">
      <div class="cart__item-content ${handleize(item.title)}">
        <div class="quick-cart__image yyy">
            <a href="${item.url}">
                <img src="${item.featured_image.url}" alt="${item.title}">
            </a>
        </div>
        <div class="quick-cart__product-2">
            <div class="quick-cart__product-details justify-between">
                <div>
                    <h4 class="ma0">
                        <a href="${item.url}">${item.title}</a>
                    </h4>
                    ${item.price == 0 ? '' : `<div class="qty_none">${option}</div>`}  
                </div>
                <div class="qty_none">
                    <button class="remove-item-btn" 
                            onclick="updatecart('/cart/change?line=${index + 1}&quantity=0', this)" 
                            data-id="${item.id}" aria-label="Remove Item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
                            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M10.714 1.286l-9.428 9.428M1.286 1.286l9.428 9.428" stroke-width=".85714"></path>
                            </g>
                        </svg>
                    </button> 
                </div>
            </div>

            ${item.price == 0 ? '' : `
                <div class="quick-cart__item-bottom">
                    <div class="quick-cart__quantity">
                        <button type="button" onclick="updatecart('/cart/change?line=${index + 1}&quantity=${item.quantity - 1}', this)" class="quick-cart__quantity-button js-remove-single_cts js-remove-single px05" aria-label="Subtract product quantity"><svg width="10" height="2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1h8" stroke="currentColor" stroke-linecap="square"></path></svg></button>
                        <div class="quick-cart__item-total js-single-quantity">${(item.quantity > 9) ? "0" + item.quantity : item.quantity}</div>
                        <button type="button" onclick="updatecart('/cart/change?line=${index + 1}&quantity=${item.quantity + 1}', this)" class="quick-cart__quantity-button js-add-single px05" aria-label="Add product quantity"><svg width="11" height="11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 0v11M0 5.5h11" stroke="currentColor"></path></svg></button>
                    </div>

                    <span class="quick-cart__product-price">
                        <span class="quick-cart__product-price-value">
                            ${price} <span>${(item.quantity > 1) ? " x " + item.quantity : ""}</span>
                        </span>
                    </span>
                </div>`}
        </div>
      </div>
    </div>`;
});

document.querySelector(".quick-cart__items_new").innerHTML = cartItem;
window.cartdata = document.querySelector(".quick-cart__items_new").innerHTML;

var total = formatMoney(data.items_subtotal_price);

setTimeout(() => {
    document.querySelector(".quick-cart__items_new").innerHTML = cartItem;
    window.cartdata = document.querySelector(".quick-cart__items_new").innerHTML;

    // Hide bonus container if any item matched 50ml/100ml
    // if (hasFreeSample) {
    //     document.querySelector(".bonus-discount-line-items-container") ? document.querySelector(".bonus-discount-line-items-container").style.display = 'block' : "";
    // } else {
    //     document.querySelector(".bonus-discount-line-items-container") ? document.querySelector(".bonus-discount-line-items-container").style.display = 'none' : "";
    // }
    document.querySelector(".bonus-discount-line-items-container") ? document.querySelector(".bonus-discount-line-items-container").style.display = 'none' : "";
    if (data.item_count == 0) {
        document.querySelector(".mfk-minicart-body-wrapper") ? document.querySelector(".mfk-minicart-body-wrapper").style.display = 'none' : "";
        document.querySelector(".mfk-minicart-body-gradient") ? document.querySelector(".mfk-minicart-body-gradient").style.display = 'none' : "";
        document.querySelector(".mfk-minicart-empty-msg") ? document.querySelector(".mfk-minicart-empty-msg").style.display = 'none' : "";
        document.querySelector(".Continue-btnun.empty_cart a") ? document.querySelector(".Continue-btnun.empty_cart a").style.display = 'flex' : "";
        document.querySelector(".mfk-minicart-empty-msg.mfk-show-on-empty") ? document.querySelector(".mfk-minicart-empty-msg.mfk-show-on-empty").style.display = 'flex' : "";
        document.querySelector(".quick-cart__footer") ? document.querySelector(".quick-cart__footer").classList.remove('active') : "";
        document.querySelector("#cart-subtotal").innerHTML = total;
    } else {
        document.querySelector(".mfk-minicart-body-gradient") ? document.querySelector(".mfk-minicart-body-gradient").style.display = 'block' : "";
        document.querySelector(".mfk-minicart-empty-msg") ? document.querySelector(".mfk-minicart-empty-msg").style.display = 'none' : "";
        document.querySelector(".Continue-btnun.empty_cart a") ? document.querySelector(".Continue-btnun.empty_cart a").style.display = 'none' : "";
        document.querySelector(".mfk-minicart-empty-msg.mfk-show-on-empty") ? document.querySelector(".mfk-minicart-empty-msg.mfk-show-on-empty").style.display = 'none' : "";
        document.querySelector(".quick-cart__footer") ? document.querySelector(".quick-cart__footer").classList.add('active') : "";
        document.querySelector("#cart-subtotal").innerHTML = total;

        // Only show bonus container if no free sample found
        if (hasFreeSample) {
            document.querySelector(".bonus-discount-line-items-container") ? document.querySelector(".bonus-discount-line-items-container").style.display = 'block' : "";
            document.querySelector(".mfk-minicart-body-wrapper") ? document.querySelector(".mfk-minicart-body-wrapper").style.display = 'block' : "";
        } else {
            document.querySelector(".bonus-discount-line-items-container") ? document.querySelector(".bonus-discount-line-items-container").style.display = 'none' : "";
            document.querySelector(".mfk-minicart-body-wrapper") ? document.querySelector(".mfk-minicart-body-wrapper").style.display = 'none' : "";
        }
    }
}, 500);

}

// Complimentary sample rule: once the non-sample subtotal reaches £100,
// up to 2 total sample units are allowed (from any sample product, added
// from anywhere - PDP or cart). Below £100, no samples are allowed at all
// and any already in the cart get removed automatically.
var SAMPLE_THRESHOLD_PENCE = 10000; // £100
var SAMPLE_MAX_QTY = 2;

function isSampleItem(item) {
    return /sample/i.test(item.title) || (item.product_tags && item.product_tags.indexOf('sample') !== -1);
}

function enforceSampleRules(data, isProduct) {
    if (!data.item_count) return;

    var nonSampleSubtotal = 0;
    var sampleLines = [];

    data.items.forEach(function (item) {
        if (isSampleItem(item)) {
            sampleLines.push(item);
        } else {
            nonSampleSubtotal += item.line_price;
        }
    });

    if (sampleLines.length === 0) return;

    var qualifies = nonSampleSubtotal >= SAMPLE_THRESHOLD_PENCE;
    var updates = {};
    var sampleQtySoFar = 0;

    sampleLines.forEach(function (item) {
        if (!qualifies) {
            // Below threshold: remove every sample line entirely.
            updates[item.key] = 0;
            return;
        }

        var remaining = SAMPLE_MAX_QTY - sampleQtySoFar;
        if (remaining <= 0) {
            updates[item.key] = 0; // limit already used up
        } else if (item.quantity > remaining) {
            updates[item.key] = remaining; // trim to what's left of the allowance
            sampleQtySoFar += remaining;
        } else {
            sampleQtySoFar += item.quantity;
        }
    });

    if (Object.keys(updates).length === 0) return;

    fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
    })
        .then(function (res) { return res.json(); })
        .then(function (updatedCart) {
            console.log('Adjusted sample items to comply with sample rules:', updates);
            updateCartUI(updatedCart, isProduct);
            updateSampleAddButtons(updatedCart);
        })
        .catch(function (err) { console.error('Error enforcing sample rules', err); });
}

// Proactively disables any "sample" product's Add to cart button on its own
// PDP once the cart already holds the max allowed sample quantity, so the
// user never sees an item get added and then silently disappear again.
function updateSampleAddButtons(data) {
    var sampleButtons = document.querySelectorAll('[data-is-sample-product]');
    if (!sampleButtons.length) return;

    var currentSampleQty = 0;
    (data.items || []).forEach(function (item) {
        if (isSampleItem(item)) currentSampleQty += item.quantity;
    });

    var limitReached = currentSampleQty >= SAMPLE_MAX_QTY;

    sampleButtons.forEach(function (btn) {
        var textEl = btn.querySelector('[data-add-to-cart-text], [data-pgs-sticky-add-to-cart-text]');
        var availableLabel = btn.getAttribute('data-lang-available') || (textEl ? textEl.getAttribute('data-original-text') : null);
        if (textEl && !textEl.getAttribute('data-original-text')) {
            textEl.setAttribute('data-original-text', textEl.textContent);
        }

        if (limitReached) {
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
            if (textEl) textEl.textContent = btn.getAttribute('data-lang-sample-limit-reached');
        } else {
            btn.disabled = false;
            btn.removeAttribute('aria-disabled');
            if (textEl) textEl.textContent = availableLabel || textEl.getAttribute('data-original-text');
        }
    });
}

function fetchCartData(isProduct) {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (data) {
            console.log(data);
            updateCartUI(data, isProduct);

            // After updateCartUI in fetchCartData
            enforceSampleRules(data, isProduct);
            updateSampleAddButtons(data);


            // Your existing "clear cart if price = 0" logic
            if (data.total_price == 0 && data.item_count > 0) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/clear.js',
                    dataType: 'json',
                    success: function (data) {
                        updateCartUI(data, isProduct);
                        if (window.location.href.includes('/cart')) {
                            window.location.reload()
                        }
                    },
                    error: function (responseText) {
                        console.log(responseText);
                    }
                });
            }
        },
        error: function (responseText) {
            console.log(responseText);
        }
    });
}


window.onload = function () {
    fetchCartData(false)
    console.log("cart fetched loaded");
}

function observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
            const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
            const isCartChangeRequest = /\/cart\//.test(entry.name);
            if (isValidRequestType && isCartChangeRequest) {
                if (window.location.href.includes('/products/')) {
                    fetchCartData(true);
                } else {
                    fetchCartData(false);
                }

            }
        });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
}
document.addEventListener("DOMContentLoaded", function () {
    fetchCartData(false);
    observeCartChanges();
});

fetchCartData(false);


jQuery(document).ready(function ($) {
    $('.categories .control').on('click', 'li', function () {
        var slideshow = $(this).closest('.categories');
        $(this).siblings(':not(.placeholder)').removeClass('active');
        $(this).addClass('active');
        slideshow.children('div:not(.placeholder)').removeClass('active').filter(':lt(' + $(this).index() + ')').addClass('left');
        slideshow.children('div:not(.placeholder):eq(' + $(this).index() + '), div:not(.placeholder):gt(' + $(this).index() + ')').removeClass('left');
        slideshow.children('div:not(.placeholder):eq(' + $(this).index() + ')').addClass('active')
    });
    $('.categories').on('click', '> div:not(.active)', function () {
        var categories = $(this).closest('.categories');
        var active = categories.find('.active');
        $(this).siblings().removeClass('active');
        if ($(this).is('.left')) {
            active.addClass('left')
        }
        $(this).removeClass('left').addClass('active')
    }).on('dragStart', '.slide', function (event) {
        if ($(this).is('.is-dragging'))
            return;
        $(this).css({
            'left': '0',
            'opacity': '1'
        }).removeClass('active').addClass('is-dragging').siblings('').removeClass('active').addClass('is-dragging');
        $(this).closest('.categories').find('.control').addClass('is-dragging').find('li').removeClass('active')
    }).on('drag', '.slide', function (event, ui) {
        if (ui) {
            var objCategories = $(this).closest('.categories');
            var intIndex = objCategories.find('.slide').index($(this))
            var fltDiff = ui.x - ui.start.ex;
            var fltPercent = fltDiff / $(this).outerWidth();
            if (fltDiff < 0) {
                var objNext = (intIndex < objCategories.find('.slide').length - 1) ? objCategories.find('.slide:eq(' + (intIndex + 1) + ')') : null;
                if (objNext) {
                    if (fltPercent >= -1) {
                        objNext.css({
                            'left': (100 + (fltPercent * 100)) + '%',
                            'opacity': 0 - fltPercent
                        });
                        $(this).css({
                            'left': (fltPercent * 100) + '%',
                            'opacity': fltPercent + 1
                        })
                    } else {
                        objNext.css({
                            'left': 0,
                            'opacity': 1
                        });
                        $(this).css({
                            'left': '-100%',
                            'opacity': 1
                        })
                    }
                } else {
                    $(this).css('left', 0)
                }
            } else {
                var objPrevious = (intIndex > 0) ? objCategories.find('.slide:eq(' + (intIndex - 1) + ')') : null;
                if (objPrevious) {
                    if (fltPercent < 1) {
                        objPrevious.css({
                            'left': (-100 + (fltPercent * 100)) + '%',
                            'opacity': fltPercent
                        });
                        $(this).css({
                            'left': (fltPercent * 100) + '%',
                            'opacity': 1 - fltPercent
                        })
                    } else {
                        objPrevious.css({
                            'left': 0,
                            'opacity': 1
                        });
                        $(this).css({
                            'left': '100%',
                            'opacity': '0'
                        })
                    }
                } else {
                    $(this).css('left', 0)
                }
            }
        }
    }).on('dragEnd', '.slide', function (event) {
        var objCategories = $(this).closest('.categories');
        var intIndex = objCategories.find('.slide').index($(this))
        var fltPercent = $(this).position().left / $(this).outerWidth();
        $(this).closest('.categories').find('.control').removeClass('is-dragging');
        if (fltPercent < -0.10) {
            var objNext = (intIndex < objCategories.find('.slide').length - 1) ? objCategories.find('.slide:eq(' + (intIndex + 1) + ')') : null;
            if (objNext) {
                $(this).addClass('left');
                objNext.removeClass('left').addClass('active');
                objCategories.find('.control li:eq(' + (intIndex + 1) + ')').addClass('active')
            }
        } else if (fltPercent > 0.10) {
            var objPrevious = (intIndex > 0) ? objCategories.find('.slide:eq(' + (intIndex - 1) + ')') : null;
            if (objPrevious) {
                objPrevious.removeClass('left').addClass('active');
                objCategories.find('.control li:eq(' + (intIndex - 1) + ')').addClass('active')
            }
        } else {
            var objPrevious = (intIndex > 0) ? objCategories.find('.slide:eq(' + (intIndex - 1) + ')') : null;
            if (objPrevious)
                objPrevious.addClass('left');
            $(this).removeClass('left').addClass('active');
            objCategories.find('.control li:eq(' + (intIndex) + ')').addClass('active')
        }
        $(this).removeClass('is-dragging').css({
            'left': '',
            'opacity': ''
        }).siblings('').removeClass('is-dragging').css({
            'left': '',
            'opacity': ''
        })
    });

    $('.carousel').each(function () {
        var objInnerDiv = $('<div class="inner"></div>');
        $(this).find('> div:first').each(function () {
            $(this).clone().addClass('slide placeholder').appendTo(objInnerDiv)
        });
        $(this).find('> div').each(function () {
            $(this).addClass('slide').detach().appendTo(objInnerDiv)
        });
        if ($(this).find('.prev').length == 0) {
            $(this).append('<div class="prev"><div></div></div>')
        }
        if ($(this).find('.next').length == 0) {
            $(this).append('<div class="next"><div></div></div>')
        }
        if ($(this).find('.control').length == 0) {
            var objControl = $('<ul class="control"></ul>');
            for (var i = 0; i < objInnerDiv.find('.slide:not(.placeholder)').length; i++) {
                objControl.append('<li></li>')
            }
            objControl.find('li:first').addClass('active');
            $(this).append(objControl)
        }
        objInnerDiv.find('.slide:not(.placeholder):first').addClass('active');
        $(this).append(objInnerDiv);
        if ($(this).is('.calendar')) {
            objInnerDiv.height(objInnerDiv.find('.slide.placeholder').outerHeight());
            $(this).find('.slide.placeholder').remove()
        }
    }).on('click', '.prev, .next', function () {
        var objDivSource = $(this).closest('.carousel').find('.inner > div:not(.placeholder).active');
        var objDivTarget = null;
        if ($(this).is('.prev')) {
            objDivTarget = objDivSource.prev().filter(':not(.placeholder)');
            if (objDivTarget.length === 0) {
                objDivTarget = $(this).closest('.carousel').find('.inner > div:not(.placeholder):last');
                $(this).closest('.carousel').find('.inner > div:not(.placeholder)').addClass('left')
            }
            objDivSource.removeClass('active');
            objDivTarget.addClass('active').removeClass('left')
        } else {
            objDivTarget = objDivSource.next().filter(':not(.placeholder)');
            if (objDivTarget.length === 0) {
                objDivTarget = $(this).closest('.carousel').find('.inner > div:not(.placeholder):first');
                $(this).closest('.carousel').find('.inner > div:not(.placeholder)').removeClass('left');
                objDivSource.removeClass('active')
            } else {
                objDivSource.removeClass('active').addClass('left')
            }
            objDivTarget.addClass('active').removeClass('left')
        }
        $(this).closest('.carousel').find('ul.control li').removeClass('active');
        $(this).closest('.carousel').find('ul.control li:eq(' + $(this).closest('.carousel').find('.inner > div:not(.placeholder)').index(objDivTarget) + ')').addClass('active')
    }).on('transitionend', '.inner', function () {
        $(this).closest('.multipanel').innerHeight($(this).closest('.multipanel').find('> li.active').outerHeight(!0))
    });
    $('.carousel ul.control').on('click', 'li', function () {
        var intSource = $(this).closest('ul').find('li.active').index();
        var intTarget = $(this).index();
        if (intSource < intTarget) {
            $(this).closest('.carousel').find('.slide:not(.placeholder):lt(' + intTarget + ')').removeClass('active').addClass('left');
            $(this).closest('.carousel').find('.slide:not(.placeholder):eq(' + intTarget + ')').removeClass('left').addClass('active')
        } else if (intTarget < intSource) {
            $(this).closest('.carousel').find('.slide:not(.placeholder):gt(' + intTarget + ')').removeClass('active').removeClass('left');
            $(this).closest('.carousel').find('.slide:not(.placeholder):eq(' + intTarget + ')').addClass('active').removeClass('left')
        }
        if (intSource !== intTarget) {
            $(this).closest('ul').find('li.active').removeClass('active');
            $(this).addClass('active')
        }
    });

    $('input[data-slide]').on('click', function () {
        var objSourceOffset = $(this).offset();
        self = $(this);
        if ($(this).prop('checked')) {
            $($(this).attr('data-slide')).slideDown({
                'duration': 300,
                'progress': function (animation, progress) {
                    $(this).css('opacity', progress)
                },
                'always': function () {
                    $(this).find('select.selector').trigger('redraw')
                }
            })
        } else {
            $($(this).attr('data-slide')).slideUp({
                'duration': 300,
                'progress': function (animation, progress) {
                    $(this).css('opacity', progress)
                },
                'always': function () {
                    $("html, body").animate({
                        scrollTop: '+=' + (self.offset().top - objSourceOffset.top) + 'px'
                    }, 300)
                }
            })
        }
    });


});

$('.multicontrol').each(function () {
    var objMultipanel = $('ul.multipanel[data-control="#' + $(this).attr('id') + '"]');
    if (objMultipanel.length > 0) {
        var objLi;
        if (window.location.hash) {
            objLi = $(this).find('li[data-hash="' + window.location.hash.match(/\#(.*)/)[1] + '"]')
        } else {
            objLi = $(this).find('li.active')
        }
        if (objLi.length == 0) {
            objLi = $(this).find('li:first')
        }
        objLi.addClass('active');
        objMultipanel.children('li:lt(' + $(this).find('li').index(objLi) + ')').addClass('left');
        objMultipanel.innerHeight(objMultipanel.children('li:eq(' + $(this).find('li').index(objLi) + ')').addClass('active').outerHeight(!0))
    }
}).on('click', 'li', function () {
    var objMultipanel = $('ul.multipanel[data-control="#' + $(this).parent().attr('id') + '"]')
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    objMultipanel.children('li').removeClass('active').filter(':lt(' + $(this).index() + ')').addClass('left');
    objMultipanel.children('li:gt(' + $(this).index() + ')').removeClass('left');
    objMultipanel.innerHeight(objMultipanel.children('li:eq(' + $(this).index() + ')').removeClass('left').addClass('active').outerHeight(!0))
});
if ("onhashchange" in window) {
    $(window).bind('hashchange', function (e) {
        var arrHash = window.location.hash.match(/\#(.*)/);
        if (arrHash) {
            var objLi = $('li[data-hash="' + arrHash[1] + '"]');
            if (objLi.length > 0) {
                var objMultipanel = $('ul.multipanel[data-control="#' + objLi.parent().attr('id') + '"]')
                objLi.siblings().removeClass('active');
                objLi.addClass('active');
                objMultipanel.children('li').removeClass('active').filter(':lt(' + objLi.index() + ')').addClass('left');
                objMultipanel.children('li:gt(' + objLi.index() + ')').removeClass('left');
                objMultipanel.innerHeight(objMultipanel.children('li:eq(' + objLi.index() + ')').removeClass('left').addClass('active').outerHeight(!0));
                $('nav.tiny').find('input:checkbox').prop('checked', !1)
            }
        }
    });






    ///// faq .js /////

    !function (t) {
        var e = {};
        function a(i) {
            if (e[i])
                return e[i].exports;
            var n = e[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return t[i].call(n.exports, n, n.exports, a),
                n.l = !0,
                n.exports
        }
        a.m = t,
            a.c = e,
            a.d = function (t, e, i) {
                a.o(t, e) || Object.defineProperty(t, e, {
                    enumerable: !0,
                    get: i
                })
            }
            ,
            a.r = function (t) {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                    value: "Module"
                }),
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    })
            }
            ,
            a.t = function (t, e) {
                if (1 & e && (t = a(t)),
                    8 & e)
                    return t;
                if (4 & e && "object" == typeof t && t && t.__esModule)
                    return t;
                var i = Object.create(null);
                if (a.r(i),
                    Object.defineProperty(i, "default", {
                        enumerable: !0,
                        value: t
                    }),
                    2 & e && "string" != typeof t)
                    for (var n in t)
                        a.d(i, n, function (e) {
                            return t[e]
                        }
                            .bind(null, n));
                return i
            }
            ,
            a.n = function (t) {
                var e = t && t.__esModule ? function () {
                    return t.default
                }
                    : function () {
                        return t
                    }
                    ;
                return a.d(e, "a", e),
                    e
            }
            ,
            a.o = function (t, e) {
                return Object.prototype.hasOwnProperty.call(t, e)
            }
            ,
            a.p = "",
            a(a.s = 262)
    }({
        210: function (t, e, a) {
            "use strict";
            const i = a(6);
            function n() {
                let t = i.isTabletOrSmaller();
                const e = window.location.hash;
                "" !== e ? function (t) {
                    const e = i.isTabletOrSmaller();
                    if (!t)
                        return !1;
                    let a = $(".col-three #" + t);
                    if (0 === a.length)
                        return !1;
                    $(".col-one .active, .col-two .active, .col-three .content.active").removeClass("active"),
                        e && ($(".faq-container .col-one li:not(.active)").hide(),
                            $(".faq-container .col-two li:not(.active)").hide());
                    let n = a.attr("data-parent")
                        , o = $(".col-two #" + n).first()
                        , r = o.find('li[data-show="#' + t + '"]').first();
                    $('.col-one li[data-show="#' + n + '"]').addClass("active").removeAttr("style"),
                        o.addClass("active").removeAttr("style"),
                        r.addClass("active").removeAttr("style"),
                        a.addClass("active"),
                        $("html, body").animate({
                            scrollTop: 0
                        }, 500)
                }(e.slice(1)) : t || ($(".col-one .active, .col-two .active, .col-three .content.active").removeClass("active"),
                    $(".col-one ul:first-child, .col-two ul:first-child, .col-three div:first-child").addClass("active"),
                    $(".col-one ul li:first-child, .col-two ul li:first-child, .col-three div:first-child").addClass("active"),
                    $(".col-one ul li:first-child").children(".faq-button").attr("aria-expanded", !0).attr("aria-current", !0),
                    $(".col-two ul li:first-child").children(".faq-button").attr("aria-expanded", !0).attr("aria-current", !0))
            }
            t.exports = {
                init: function () {
                    let t = i.isTabletOrSmaller();
                    n(),
                        window.addEventListener("hashchange", n, !1),
                        $(".faq-container .col-one li").on("click", (function () {
                            if ($(this).hasClass("active"))
                                t && ($(".col-one .active, .col-two .active, .col-three .content.active").children(".faq-button").attr("aria-expanded", !1).removeAttr("aria-current"),
                                    $(".col-one .active, .col-two .active, .col-three .content.active").removeClass("active"),
                                    $(".client-service .col-one li").show(),
                                    $(".faq-container ul, .faq-container li").removeAttr("style"),
                                    $(".col-two .faq-vline").hide());
                            else if ($(".col-one .active, .col-two .active, .col-three .content.active").children(".faq-button").attr("aria-expanded", !1).removeAttr("aria-current"),
                                $(".col-one .active, .col-two .active, .col-three .content.active").removeClass("active"),
                                $(this).addClass("active"),
                                $(this).addClass("active").children(".faq-button").attr("aria-expanded", !0).attr("aria-current", !0),
                                $($(this).attr("data-show")).addClass("active"),
                                $($(this).attr("data-show")).children(".faq-button").attr("aria-expanded", !0).attr("aria-current", !0),
                                t)
                                $(".faq-container .col-one li:not(.active)").hide(),
                                    $(".col-two .faq-vline").hide();
                            else {
                                var e = $($(this).attr("data-show")).find("li").first();
                                e.addClass("active"),
                                    e.children(".faq-button").attr("aria-expanded", !0).attr("aria-current", !0),
                                    e = e.attr("data-show"),
                                    $(e).addClass("active"),
                                    $(e).children(".faq-button").attr("aria-expanded", !0).attr("aria-current", !0)
                            }
                        }
                        )),
                        $(".faq-container .col-two li").on("click", (function (e) {
                            e.stopPropagation(),
                                e.preventDefault(),
                                $(this).hasClass("active") ? t && ($(".col-two .active").children(".faq-button").attr("aria-expanded", !1).removeAttr("aria-current"),
                                    $(".col-two .active, .col-three .content.active").removeClass("active"),
                                    $(this).parent().show(),
                                    $(this).parent().find("li").show(),
                                    $(".col-two .faq-vline").hide()) : ($(".col-two li.active").children(".faq-button").attr("aria-expanded", !1).removeAttr("aria-current"),
                                        $(".col-two li.active, .col-three .content.active").removeClass("active"),
                                        $(this).addClass("active"),
                                        $(this).children(".faq-button").attr("aria-expanded", !0).attr("aria-current", !0),
                                        t && ($(".col-two .faq-vline").show(),
                                            $(".faq-container .col-two li:not(.active)").hide()),
                                        $($(this).attr("data-show")).addClass("active"))
                        }
                        )),
                        $(window).on("resize", (function () {
                            t = i.isTabletOrSmaller()
                        }
                        ))
                }
            }
        },
        262: function (t, e, a) {
            "use strict";
            var i = a(5);
            $((function () {
                i(a(210))
            }
            ))
        },
        5: function (t, e, a) {
            "use strict";
            t.exports = function (t) {
                "function" == typeof t ? t() : "object" == typeof t && Object.keys(t).forEach((function (e) {
                    "function" == typeof t[e] && t[e]()
                }
                ))
            }
        },
        6: function (t, e, a) {
            "use strict";
            function i() {
                return $(".is-mobile").length > 0 && "block" === $(".is-mobile").css("display")
            }
            function n() {
                return $(".is-tablet").length > 0 && "block" === $(".is-tablet").css("display")
            }
            t.exports = {
                isMobile: i,
                isTablet: n,
                isTabletOrSmaller: function () {
                    return n() || i()
                },
                isInViewPort: function (t, e, a) {
                    if (t instanceof jQuery || (t = $(t)),
                        void 0 === t)
                        return;
                    if (void 0 === t.offset())
                        return;
                    void 0 === a && (a = 0);
                    let i = $(window).scrollTop()
                        , n = i + $(window).height()
                        , o = t.offset().top + a
                        , r = o + t.height();
                    return !0 === e ? i < o && n > r : o <= n && r >= i
                },
                supportTouch: function () {
                    return "ontouchstart" in window || navigator.msMaxTouchPoints
                }
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const togglers = document.querySelectorAll('[data-toggle-to]');
    let activeToggler = null;

    if (togglers.length > 0) {
        const firstToggler = togglers[0];
        const firstBlock = document.querySelector(firstToggler.dataset.toggleTo);

        if (firstBlock) {
            firstBlock.style.height = firstBlock.scrollHeight + 'px';
            firstToggler.classList.add('active');
            activeToggler = firstToggler;
        }
    }

    togglers.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            const selector = e.currentTarget.dataset.toggleTo;
            const block = document.querySelector(selector);

            if (!block) {
                console.log(`Element not found for selector: ${selector}`);
                return;
            }

            // 👉 Check if clicked on the active toggler
            if (activeToggler === btn) {
                // Collapse the active block
                block.style.height = '0';
                btn.classList.remove('active');
                activeToggler = null;
                return; // exit
            }

            // 👉 Close the previously active block
            if (activeToggler) {
                const activeSelector = activeToggler.dataset.toggleTo;
                const activeBlock = document.querySelector(activeSelector);
                if (activeBlock) {
                    activeBlock.style.height = '0';
                }
                activeToggler.classList.remove('active');
            }

            // 👉 Open the clicked block
            block.style.height = block.scrollHeight + 'px';
            btn.classList.add('active');
            activeToggler = btn;
        });
    });
});




document.addEventListener("DOMContentLoaded", () => {
    const listItems = document.querySelectorAll(".image_change");
    const selectElement = document.querySelector("select[data-variant-select]");
    listItems.forEach((item) => {
        item.addEventListener("click", () => {
            const value = item.getAttribute("data-value");
            selectElement.value = value;
            const event = new Event("change");
            selectElement.dispatchEvent(event);
        });
    });

    setTimeout(() => {
        if (listItems[0]) {
            listItems[0].click()
        }
    }, 500);
});


document.addEventListener("DOMContentLoaded", () => {
    const autoClickInput = document.querySelector('input.listing.active[checked]');
    if (autoClickInput) {
        autoClickInput.click();
    }
});

document.addEventListener("DOMContentLoaded", () => {
    const swiper = new Swiper("#product_gallery", {
        loop: false,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 10,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: false,
            },
            959: {
                slidesPerView: 3,
                spaceBetween: 20,
                pagination: false,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
        },
    });
});


document.addEventListener('DOMContentLoaded', () => {
    const isMobile = window.matchMedia("(max-width: 749px)").matches;

    $('.topimage_box').slick({
        dots: isMobile,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        vertical: !isMobile,
        verticalSwiping: !isMobile,
        responsive: [
            {
                breakpoint: 750,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    dots: true,
                }
            }
        ]
    });


    $(".mfk-arrow-prev").click(function () {
        $(".topimage_box").slick("slickPrev");
    });

    $(".mfk-arrow-next").click(function () {
        $(".topimage_box").slick("slickNext");
    });
    $(".mfk-arrow-prev").addClass("slick-disabled");
    $(".topimage_box").on("afterChange", function () {
        if ($(".slick-prev").hasClass("slick-disabled")) {
            $(".mfk-arrow-prev").addClass("slick-disabled");
        } else {
            $(".mfk-arrow-prev").removeClass("slick-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
            $(".mfk-arrow-next").addClass("slick-disabled");
        } else {
            $(".mfk-arrow-next").removeClass("slick-disabled");
        }
    });
});


$('.topimage_box').on('afterChange', function (event, slick, currentSlide) {
    document.querySelector('.js-currentSlideNumber').textContent = currentSlide + 1;
});

if (document.querySelector('.js-currentSlideNumber')) {
    document.querySelector('.js-currentSlideNumber').textContent = 1;
}



$('.topimage_box').on('init', function (event, slick) {
    const $customDots = $('<ul class="custom-dots"></ul>');
    slick.$slides.each((index) => {
        $customDots.append(`<li class="custom-dot" data-slide="${index}">${index + 1}</li>`);
    });
    $('.custom-dots-container').append($customDots);

    $customDots.find('.custom-dot').first().addClass('active');
});

function refreshCart() {
    setTimeout(() => {
        if (document.querySelector(".cart_drawer_cts").classList.contains('is-visible')) {
            if (window.cartdata != null) {
                document.querySelector(".quick-cart__items_new").innerHTML = window.cartdata;
            }
        } else {
            window.cartdata = document.querySelector(".quick-cart__items_new").innerHTML;
        }
    }, 100);
}

document.querySelector('.js-cart-drawer-toggle').addEventListener("click", function () {
    refreshCart()
})



document.querySelector("[data-drawer-overlay]").addEventListener("click", function () {
    refreshCart()
})





// Custom Dropdown Element
class PIDropdownMenu extends HTMLElement {
    constructor() {
      super();
      
      // Element references
      this.toggle = null;
      this.menu = null;
      this.isOpen = false;
      
      // Bind methods
      this.handleToggleClick = this.handleToggleClick.bind(this);
      this.handleItemClick = this.handleItemClick.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    
    connectedCallback() {
      this.toggle = this.querySelector('.dropdown__toggle');
      this.menu = this.querySelector('.dropdown__menu');
      
      if (!this.toggle || !this.menu) return;
      
      // Add event listeners
      this.toggle.addEventListener('click', this.handleToggleClick);
      
      // Add click listeners for all dropdown items
      const items = this.querySelectorAll('.dropdown__item');
      items.forEach(item => {
        item.addEventListener('click', this.handleItemClick);
      });
      
      // Add global click listener for closing dropdown when clicking outside
      document.addEventListener('click', this.handleClickOutside);
    }
    
    disconnectedCallback() {
      // Clean up event listeners
      if (this.toggle) {
        this.toggle.removeEventListener('click', this.handleToggleClick);
      }
      
      const items = this.querySelectorAll('.dropdown__item');
      items.forEach(item => {
        item.removeEventListener('click', this.handleItemClick);
      });
      
      document.removeEventListener('click', this.handleClickOutside);
    }
    
    handleToggleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      
      if (this.isOpen) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    }
    
    handleItemClick() {
      // Close dropdown when an item is clicked
      this.closeDropdown();
    }
    
    handleClickOutside(event) {
      // Close dropdown when clicking outside
      if (this.isOpen && !this.contains(event.target)) {
        this.closeDropdown();
      }
    }
    
    openDropdown() {
        this.isOpen = true;
        this.toggle.setAttribute('aria-expanded', 'true');
        this.menu.classList.add('dropdown__menu--open');
      
        // Find closest .shopify-section and add class
        const section = this.menu.closest('.shopify-section');
        if (section) {
          section.classList.add('pi-dropdown-opened');
        }
      }
      
      closeDropdown() {
        this.isOpen = false;
        this.toggle.setAttribute('aria-expanded', 'false');
        this.menu.classList.remove('dropdown__menu--open');
      
        // Find closest .shopify-section and remove class
        const section = this.menu.closest('.shopify-section');
        if (section) {
          section.classList.remove('pi-dropdown-opened');
        }
      }
      
  }

  // Register the custom element
  customElements.define('pi-dropdown-menu', PIDropdownMenu);




  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
  
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
  
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
  
            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }
  
            if (html.querySelector('.pi-recommend-slide')) {
              this.classList.add('product-recommendations--loaded');
            }
            // Initialize Slick Carousel
function initializeCarousel(target, slidesToShow, infiniteLoop) {
    $(target).slick({
        lazyLoad: "ondemand",
        accessibility: true,
        mobileFirst: true,
        rows: 0,
        slidesToShow: slidesToShow,
        touchThreshold: 100,
        infinite: infiniteLoop,
        speed: 300,
        arrow: true,
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 3
            }
        }]
    });
}

// Handle recommendations carousel based on screen size
function handleRecommendations() {
    if (window.matchMedia("(max-width: 767px)").matches) {
        $(".js-fragranceFinder-recommendations").each(function(index, element) {
            if (!$(element).hasClass("slick-initialized")) {
                initializeCarousel(element, 1, true);
            }
        });
    }
}

// Initialize slider indicators
function initializeSliderIndicators() {
    $(".js-sliderIndicators").each(function(index, indicatorElement) {
        var $indicator = $(indicatorElement);
        var $targetSlider = $($indicator.attr("data-target"));

        if ($targetSlider.length) {
            var $span = $indicator.find("span");

            if ($span.length && !$indicator.data("slider-init")) {
                $indicator.data("slider-init", true);

                $targetSlider.on("init", function(event, slick) {
                    updateIndicator(slick.currentSlide, slick.slideCount, $indicator, $targetSlider, $span);
                });

                $targetSlider.on("beforeChange", function(event, slick, currentSlide, nextSlide) {
                    updateIndicator(nextSlide, slick.slideCount, $indicator, $targetSlider, $span);
                });
            }
        }

        function updateIndicator(currentSlide, totalSlides, $indicator, $slider, $span) {
            var visibleSlides = totalSlides - $slider.find(".slick-active").length + 1;

            if (visibleSlides > 1) {
                var widthPercent = 100 / visibleSlides;
                var leftPercent = widthPercent * currentSlide;
                $span.css("width", widthPercent + "%");
                $span.css("left", leftPercent + "%");
                $indicator.show();
            } else {
                $indicator.hide();
            }
        }
    });
}

// Main init function
function initProductCarousels() {
    initializeSliderIndicators();

    $(".js-productCarousel-recommendations").each(function(index, element) {
        initializeCarousel(element, 1.5, false);
    });

    handleRecommendations();

    $(window).on("resize orientationchange", handleRecommendations);
}
initProductCarousels();

          })
          .catch((e) => {
            console.error(e);
          });
      };
  
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
    }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);